module.exports = __webpack_public_path__ + "static/media/websiteIcon.812832e6.jpg";